import React from 'react';
import { StatusPill } from '../../../components';

/**
 * Words and colours for Rota > Available Shifts. The API decides every state
 * (api/utils/openShifts.js) — these only name it.
 */
export { errorMessage } from '../care_planner/shared';

// An offered shift.
export const SHIFT_STATE = {
  open: { label: 'Open', tone: 'info' },
  filled: { label: 'Filled', tone: 'good' },
  expired: { label: 'Not filled', tone: 'crit' },
  cancelled: { label: 'Cancelled', tone: 'mute' },
};

// One carer's request for it.
export const REQUEST_STATE = {
  requested: { label: 'Waiting', tone: 'warn' },
  approved: { label: 'Approved', tone: 'good' },
  declined: { label: 'Declined', tone: 'crit' },
  withdrawn: { label: 'Withdrawn', tone: 'mute' },
  closed: { label: 'Closed', tone: 'mute' },
};

export const StatePill = ({ map, state }) => {
  const meta = map[state] || { label: state, tone: 'mute' };
  return <StatusPill tone={meta.tone}>{meta.label}</StatusPill>;
};
